import { takeLatest, takeEvery } from 'redux-saga/effects';
import * as types from '../constants/ActionTypes';
import {
  checkout,
  publishProduct,
  sendPublishData,
  patchProductV1,
  fetchProduct,
} from './publishing/publishingProductSaga';
import {
  postListedData,
  sendListedData,
  deleteListedData,
  convertAudioGuides,
} from './publishing/publishingListedSaga';
import {
  deleteMultipleImages,
  syncProductImagesOrder,
  reorderProductImages,
} from './publishing/publishingMediaSaga';
import {
  sendAttractionsData,
  sendTicketsData,
  sendTicketCategoriesData,
  deleteTicket,
} from './publishing/publishingAttractionsSaga';

export {
  checkout,
  publishProduct,
  sendPublishData,
  patchProductV1,
  fetchProduct,
  postListedData,
  sendListedData,
  deleteListedData,
  convertAudioGuides,
  deleteMultipleImages,
  syncProductImagesOrder,
  reorderProductImages,
  sendAttractionsData,
  sendTicketsData,
  sendTicketCategoriesData,
  deleteTicket,
};

export default function* watchPublishing() {
  yield takeEvery(types.RECEIVE_PAYMENT, checkout);
  yield takeLatest(types.PUBLISH_PRODUCT, publishProduct);
  yield takeEvery(types.SEND_PUBLISH_DATA, sendPublishData);
  yield takeEvery(types.PATCH_PRODUCT_V1, patchProductV1);
  yield takeEvery(types.POST_LISTED_DATA, postListedData);
  yield takeEvery(types.SEND_LISTED_DATA, sendListedData);
  yield takeEvery(types.DELETE_LISTED_DATA, deleteListedData);
  yield takeEvery(types.DELETE_MULTIPLE_IMAGES, deleteMultipleImages);
  yield takeEvery(types.REQUEST_PRODUCT, fetchProduct);
  yield takeEvery(types.SEND_ATTRACTIONS_DATA, sendAttractionsData);
  yield takeEvery(types.SEND_TICKETS_DATA, sendTicketsData);
  yield takeEvery(types.SEND_TICKETS_CATEGORIES_DATA, sendTicketCategoriesData);
  yield takeEvery(types.DELETE_TICKET, deleteTicket);
  yield takeEvery(types.CONVERT_AUDIO_GUIDES_PRICES, convertAudioGuides);
  yield takeEvery(types.REORDER_PRODUCT_IMAGES_SYNC, reorderProductImages);
  yield takeLatest(types.SYNC_PRODUCT_IMAGES_ORDER, syncProductImagesOrder);
}
